// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-user-edit-modal-modal_card-qehNS {
  width: 340px;
  height: auto;
}

.business-user-edit-modal-modal_content-Imbyx {
  padding: 0px 20px 20px;
}

.business-user-edit-modal-modal_primaryButtonBase-MtVOU {
  margin-left: 32px;
}

.business-user-edit-modal-textField_container-D30pO {
  width: 100%;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/business-users/business-user-edit-modal/business-user-edit-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n}\n\n.modal_content {\n  padding: 0px 20px 20px;\n}\n\n.modal_primaryButtonBase {\n  margin-left: 32px;\n}\n\n.textField_container {\n  width: 100%;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `business-user-edit-modal-modal_card-qehNS`,
	"modal_content": `business-user-edit-modal-modal_content-Imbyx`,
	"modal_primaryButtonBase": `business-user-edit-modal-modal_primaryButtonBase-MtVOU`,
	"textField_container": `business-user-edit-modal-textField_container-D30pO`
};
export default ___CSS_LOADER_EXPORT___;
